import { useMemo } from 'react';
import type { BoxProps, FlexProps } from '@chakra-ui/react';
import { Box, Flex } from '@chakra-ui/react';

type Props = {
  vertical?: boolean;
};

export const LogoUnderline = ({ vertical = false }: Props = { vertical: false }) => {
  const { container, line1, line2 } = useMemo(() => {
    const props: Record<
      'vertical' | 'horizontal',
      { container: FlexProps; line1: BoxProps; line2: BoxProps }
    > = {
      horizontal: {
        container: { width: '220px', alignItems: 'center', mt: 1 },
        line1: { width: '100%', height: '2px' },
        line2: { width: '75%', height: '4px' },
      },
      vertical: {
        container: {
          height: '100%',
          minHeight: '4rem',
          justifyContent: 'center',
          alignItems: 'flex-start',
          mt: 1,
        },
        line1: { height: '100%', width: '2px' },
        line2: { height: '65%', width: '4px' },
      },
    };

    return props[vertical ? 'vertical' : 'horizontal'];
  }, [vertical]);

  return (
    <Flex position='relative' {...container}>
      <Box position='absolute' backgroundColor='secondary200' {...line1} />
      <Box position='absolute' backgroundColor='secondary400' {...line2} />
    </Flex>
  );
};
